var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspectroLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4481_89200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    transform: "matrix(1 0 0 -1 0.00012207 64)",
    fill: "#EBFCF5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2605 40.3864C23.0665 38.9914 20.8343 35.8047 20.8343 32.0966C20.8343 28.3888 23.0661 25.2023 26.2596 23.8071C25.1523 23.3235 23.9295 23.0552 22.644 23.0552C17.6503 23.0552 13.6022 27.1033 13.6022 32.0969C13.6022 37.0906 17.6503 41.1387 22.644 41.1387C23.9298 41.1387 25.153 40.8703 26.2605 40.3864Z",
    fill: "#2B323B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9028 40.3867C34.7955 40.8704 33.5725 41.1387 32.2869 41.1387C27.2933 41.1387 23.2451 37.0906 23.2451 32.0969C23.2451 27.1033 27.2933 23.0552 32.2869 23.0552C33.5727 23.0552 34.7958 23.3236 35.9032 23.8074C32.7093 25.2024 30.4772 28.3891 30.4772 32.0971C30.4772 35.805 32.7091 38.9916 35.9028 40.3867Z",
    fill: "#56CD9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8072 32.063C49.8072 27.7144 46.2819 24.1892 41.9333 24.1892C37.5846 24.1892 34.0594 27.7144 34.0594 32.063C34.0594 36.4116 37.5846 39.9368 41.9333 39.9368C46.2819 39.9368 49.8072 36.4116 49.8072 32.063Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.13022
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4481_89200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspectroLogoCircle);
export default __webpack_public_path__ + "static/media/espectro-logo-circle.32ef5020482badbfc744f59c71571da1.svg";
export { ForwardRef as ReactComponent };